<template>
    <div class="coin-body">
        <div class="top-container mt-5">
            <div class="coin-container mb-3" v-for="row in rows" v-bind:key="row.id">
                <div style="width: 40%;">
                    <img :src="require('../assets/images/' + row.imageName + '')" width=65 height=65/>
                </div>
                <div class="d-flex flex-column justify-content-center coin">
                    <div>
                        <h5><strong>{{ row.name }}</strong></h5>
                    </div>
                    <div class="text-gray small">
                        {{ row.code }}
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-4">
            <form id="coin-form">      
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label>Cold Wallet Address:</label>
                        
                        <div class="input-div" >
                            <input type="text" class="form-control" id="coldWalletAddress" value="addr1qxx7gkwm...9w75qtwxqhu">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Alert Amount:</label>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="alertAmt" value="1.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                </div>
                
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <div class="label-class">
                            <label>Sent Threshold:</label>

                            <div class="info-icon-container">
                                <div class="info-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21.527" height="21.527" viewBox="0 0 23.527 23.527">
                                        <g id="Group_512" data-name="Group 512" transform="translate(-1118.785 333.415)" opacity="0.3">
                                            <path id="Path_145" data-name="Path 145" d="M1130.549-309.888a11.777,11.777,0,0,1-11.764-11.764,11.778,11.778,0,0,1,11.764-11.764,11.777,11.777,0,0,1,11.763,11.764A11.776,11.776,0,0,1,1130.549-309.888Zm0-21.389a9.636,9.636,0,0,0-9.625,9.625,9.635,9.635,0,0,0,9.625,9.625,9.635,9.635,0,0,0,9.625-9.625A9.636,9.636,0,0,0,1130.549-331.276Z" transform="translate(0 0)" fill="#fff"/>
                                            <circle id="Path-84" cx="1.439" cy="1.439" r="1.439" transform="translate(1129.11 -328.602)" fill="#fff"/>
                                            <rect id="Rectangle_212" data-name="Rectangle 212" width="2.446" height="9.629" rx="1.062" transform="translate(1129.327 -324.329)" fill="#fff"/>
                                        </g>
                                    </svg>

                                    <div class="tooltiptext">
                                        To set a limit required for sending funds.
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="sentThreshold" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <div class="label-class">
                            <label>Receive Threshold:</label>
                            
                            <div class="info-icon-container">
                                <div class="info-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21.527" height="21.527" viewBox="0 0 23.527 23.527">
                                        <g id="Group_512" data-name="Group 512" transform="translate(-1118.785 333.415)" opacity="0.3">
                                            <path id="Path_145" data-name="Path 145" d="M1130.549-309.888a11.777,11.777,0,0,1-11.764-11.764,11.778,11.778,0,0,1,11.764-11.764,11.777,11.777,0,0,1,11.763,11.764A11.776,11.776,0,0,1,1130.549-309.888Zm0-21.389a9.636,9.636,0,0,0-9.625,9.625,9.635,9.635,0,0,0,9.625,9.625,9.635,9.635,0,0,0,9.625-9.625A9.636,9.636,0,0,0,1130.549-331.276Z" transform="translate(0 0)" fill="#fff"/>
                                            <circle id="Path-84" cx="1.439" cy="1.439" r="1.439" transform="translate(1129.11 -328.602)" fill="#fff"/>
                                            <rect id="Rectangle_212" data-name="Rectangle 212" width="2.446" height="9.629" rx="1.062" transform="translate(1129.327 -324.329)" fill="#fff"/>
                                        </g>
                                    </svg>

                                    <div class="tooltiptext" id="receive-threshold">
                                        A limit to inform user to top up their hot wallet from the cold wallet.
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="receiveThreshold" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label>Spend Limit:</label>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="spendLimit" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Send Threshold:</label>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="sendThreshold" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label>Day Spend Limit:</label>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="daySpendLimit" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Hour Spend Limit:</label>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="hourSpendLimit" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6">
                        <div class="label-class">
                            <label>Required Confirmation:</label>

                            <div class="info-icon-container">
                                <div class="info-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21.527" height="21.527" viewBox="0 0 23.527 23.527">
                                        <g id="Group_512" data-name="Group 512" transform="translate(-1118.785 333.415)" opacity="0.3">
                                            <path id="Path_145" data-name="Path 145" d="M1130.549-309.888a11.777,11.777,0,0,1-11.764-11.764,11.778,11.778,0,0,1,11.764-11.764,11.777,11.777,0,0,1,11.763,11.764A11.776,11.776,0,0,1,1130.549-309.888Zm0-21.389a9.636,9.636,0,0,0-9.625,9.625,9.635,9.635,0,0,0,9.625,9.625,9.635,9.635,0,0,0,9.625-9.625A9.636,9.636,0,0,0,1130.549-331.276Z" transform="translate(0 0)" fill="#fff"/>
                                            <circle id="Path-84" cx="1.439" cy="1.439" r="1.439" transform="translate(1129.11 -328.602)" fill="#fff"/>
                                            <rect id="Rectangle_212" data-name="Rectangle 212" width="2.446" height="9.629" rx="1.062" transform="translate(1129.327 -324.329)" fill="#fff"/>
                                        </g>
                                    </svg>

                                    <div class="tooltiptext">
                                        The amount of confirmation required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="daySpendLimit" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <div class="label-class">
                            <label>Network Fee:</label>

                            <div class="info-icon-container">
                                <div class="info-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21.527" height="21.527" viewBox="0 0 23.527 23.527">
                                        <g id="Group_512" data-name="Group 512" transform="translate(-1118.785 333.415)" opacity="0.3">
                                            <path id="Path_145" data-name="Path 145" d="M1130.549-309.888a11.777,11.777,0,0,1-11.764-11.764,11.778,11.778,0,0,1,11.764-11.764,11.777,11.777,0,0,1,11.763,11.764A11.776,11.776,0,0,1,1130.549-309.888Zm0-21.389a9.636,9.636,0,0,0-9.625,9.625,9.635,9.635,0,0,0,9.625,9.625,9.635,9.635,0,0,0,9.625-9.625A9.636,9.636,0,0,0,1130.549-331.276Z" transform="translate(0 0)" fill="#fff"/>
                                            <circle id="Path-84" cx="1.439" cy="1.439" r="1.439" transform="translate(1129.11 -328.602)" fill="#fff"/>
                                            <rect id="Rectangle_212" data-name="Rectangle 212" width="2.446" height="9.629" rx="1.062" transform="translate(1129.327 -324.329)" fill="#fff"/>
                                        </g>
                                    </svg>

                                    <div class="tooltiptext">
                                        Processing Fee.
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="input-div" >
                            <input type="number" class="form-control" id="hourSpendLimit" value="2.00000000">
                            <b-button class="edit-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="Icons_Glyph_20_Ink_Light_edit" data-name="Icons Glyph 20 Ink Light edit" transform="translate(-935.35 -103.778)" opacity="0.2">
                                        <g id="Group-17">
                                            <path id="Path-64" d="M947.05,121.176h6.377" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-65" d="M946.2,106.234a1.947,1.947,0,0,1,2.74-.273c.046.038.09.078.133.12l1.39,1.09a1.945,1.945,0,0,1,.634,2.678c-.03.049-.063.1-.1.143l-8.29,10.575a1.481,1.481,0,0,1-1.15.568l-3.2.041-.721-3.115a1.485,1.485,0,0,1,.277-1.252Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                            <path id="Path-66" d="M944.653,108.214l4.794,3.758" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
                                        </g>
                                    </g>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="form-group row d-flex justify-content-center">
                    <div class="col-sm-6 mt-5">
                        <button type="submit" class="submit-btn">Submit</button>
                    </div>                               
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default ({
    name: "CoinSetting",
    data() {
        return {
            rows: [
                {
                    id: this.$route.params.id,
                    imageName: 'bitcoin.png',
                    name: 'Bitcoin',
                    code: 'BTC', 
                }
            ]    
              
        }
    }
});
</script>

<style>
@import '../css/styles.css';

.coin-body{
    margin: 0% 15%;
    height: 100%;
    overflow: scroll;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.coin-body::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.coin-body {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.top-container{
    border-bottom: 1px solid white;
    display: flex;
    justify-content: center;
}

.coin-container{
    display: flex;
    flex-direction: row;
    width: 220px;
    color: white;
}

#coin-form label {
    display: flex;
    justify-content: center;
    color: lightslategray;
}

#coin-form input {
    background-color: var(--info-10);
    border: none;
    color: var(--info);
    text-align: center;
    border-radius: 30px;
    width: 100%;
}

.input-div {
    display: flex;
    position: relative;
    align-items: center;
}

.edit-btn {
    position: absolute;
    z-index: 1;
    right: 5%;
    color: lightslategray;
    border: none; 
    background: transparent;
}

.label-class {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
}

.info-icon-container {
    position: absolute;
    right: 7%;
    font-size: 18px;
    color: lightslategray;
}

.info-icon {
    position: relative;
    display: flex;
    flex-direction: column;
    place-items: flex-end;
}

.info-icon .tooltiptext {
    visibility: hidden;
    white-space: nowrap;
    background-color: var(--primary);
    color: black;
    text-align: center;
    border-radius: 6px;
    padding: 5px 10px;
    position: absolute;
    z-index: 1;
    font-size: 13px;
    bottom: 130%;
}

.info-icon .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--primary) transparent transparent transparent;
}

.info-icon:hover .tooltiptext {
    visibility: visible;
}

@media only screen and (max-width: 666px) and (max-width: 466px) { 
    .coin-body {
        margin: 0% 5%;
    }

    #receive-threshold {
        max-height: 45px;
        width: 270px;
        white-space: normal;
    }

    #receive-threshold::after {
        margin-left: 45px;
    }
}
</style>